import { ParticipantsPersonEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useParticipantsPersonEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new ParticipantsPersonEventsApi(configuration),
    [configuration]
  );
};
